import { Snackbar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { forwardRef } from "react";
import { Severity } from "../../types";

interface Props {
  severity: Severity;
  text: string;
  onClose: () => void;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return (
    <MuiAlert
      sx={{ color: props.severity === "success" ? "white" : "black" }}
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
    />
  );
});

const AlertComponent = (props: Props) => {
  const { severity, text, onClose } = props;

  return (
    <Snackbar open>
      <Alert severity={severity}>{text}</Alert>
    </Snackbar>
  );
};

export default AlertComponent;
